function supportsObjectFit(): boolean {
    const div = document.createElement("div");
    const vendors = "Khtml Ms O Moz Webkit".split(" ");

    let prop = "object-fit";
    let len = vendors.length;

    if (prop in div.style) {
        return true;
    }

    prop = prop.replace(/^[a-z]/, (val) => {
        return val.toUpperCase();
    });

    while (len--) {
        if (vendors[len] + prop in div.style) {
            return true;
        }
    }
    return false;
}

export default function objectFitPolyfill(document: Document, window: Window): Promise<any> {
    if (supportsObjectFit()) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        // tslint:disable-next-line:no-console
        console.debug("Polyfill: Polyfilling object-fit...");
        (require as any).ensure(["object-fit-polyfill/src/object-fit-polyfill"], (require: any) => {
            require("object-fit-polyfill/src/object-fit-polyfill");
            resolve();
        });
    });
}



// WEBPACK FOOTER //
// ./polyfill/object-fit/object-fit.polyfill.ts